import { render } from "./ErrorIcon.vue?vue&type=template&id=2fda8cf4"
const script = {}

import exportComponent from "D:\\Workspace\\JFAuthPro-svn\\前端数据展示\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__